module.exports = __webpack_public_path__ + "images/blog/blog_card/questions/33_42b913df35e6504171d43e982a27ba4f.jpg";